import type { Contact } from '@models/next/Contact';
import { createStrings } from '@utils/local';

export const contactStrings = createStrings({
  ja: {
    city: '都市',
    company_name: '社名',
    english_name: '英字社名',
    zip_code: '郵便番号',
    address: '住所',
    address1: '住所1',
    address2: '住所2',
    address1_cn: '都市名（中国語）',
    principal_name: '担当者名',
    phone: '電話番号',
    email: 'メール',
    sns_id: 'SNS ID',
    receiverRequired: `納品先は必須です。`,
    city_name: '都市名（英字名）',
    city_name_cn: '都市名（中国語）',
    pref: '都道府県',
    city_japan: '市区町村',
    social_credit_id: 'USCI',
    usciDuplicatedError: 'このUSCIがすでに他のSHIPPER情報で登録されています。ご確認下さい',
    usciFormatError: 'ご入力の情報に誤りがあります。ご確認下さい',
  },
});

export const contactRequestStrings = createStrings({
  ja: {
    requestsToConnectShipperSent: 'SHIPPER（輸出者）へのリクエスト',
    requestsToConnectConsigneeSent: 'CNEE（輸入者）へのリクエスト',
    requestsToConnectReceived: '受信した連携リクエスト',
    requestsToConnect: '連携リクエスト',
  },
} as const);

export const fakeReceivers: Contact[] = [
  {
    id: 1000001,
    english_name: 'D2D TOKYO',
    company_name: 'D2D東京',
    zip_code: '1030001',
    address1: '東京都中央区',
    address1_cn: '东京都中央区',
    address2: '',
    email: '',
    principal_name: 'D2D TOKYO',
    phone: '03-1234-5678',
    sns_id: '',
    social_credit_id: '',
    use_count: 0,
    created_at: '',
    updated_at: '',
    user: null,
    owner: null,
    contact_type: 'receiver',
    company_id: null,
    related_contacts: [],
  },
  {
    id: 1000002,
    english_name: 'D2D OSAKA',
    company_name: 'D2D大阪',
    zip_code: '5400001',
    address1: '大阪市中央区',
    address1_cn: '大阪市中央区',
    address2: '',
    email: '',
    principal_name: 'D2D OSAKA',
    phone: '06-1234-5678',
    sns_id: '',
    social_credit_id: '',
    use_count: 0,
    created_at: '',
    updated_at: '',
    user: null,
    owner: null,
    contact_type: 'receiver',
    company_id: null,
    related_contacts: [],
  },
  {
    id: 1000003,
    english_name: 'D2D NAGOYA',
    company_name: 'D2D名古屋',
    zip_code: '4600001',
    address1: '名古屋市中央区',
    address1_cn: '名古屋市中央区',
    address2: '',
    email: '',
    principal_name: 'D2D NAGOYA',
    phone: '052-123-456',
    sns_id: '',
    social_credit_id: '',
    use_count: 0,
    created_at: '',
    updated_at: '',
    user: null,
    owner: null,
    contact_type: 'receiver',
    company_id: null,
    related_contacts: [],
  },
  {
    id: 1000004,
    english_name: 'D2D HAKATA',
    company_name: 'D2D博多',
    zip_code: '8100001',
    address1: '博多中央区',
    address1_cn: '博多中央区',
    address2: '',
    email: '',
    principal_name: 'D2D HAKATA',
    phone: '092-123-456',
    sns_id: '',
    social_credit_id: '',
    use_count: 0,
    created_at: '',
    updated_at: '',
    user: null,
    owner: null,
    contact_type: 'receiver',
    company_id: null,
    related_contacts: [],
  },
];
